var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3337 4.64104L20.6993 9.33337H17.1667C16.707 9.33337 16.3337 8.88887 16.3337 8.34171V4.64104ZM23.0315 8.54937L17.8457 2.71604C17.6252 2.47221 17.3113 2.33337 16.9823 2.33337H7.64899C6.00399 2.33337 4.66699 3.64237 4.66699 5.25004V22.75C4.66699 24.3577 6.00399 25.6667 7.64899 25.6667H20.3517C21.9967 25.6667 23.3337 24.3577 23.3337 22.75V9.33337C23.3337 9.04287 23.2263 8.76404 23.0315 8.54937Z",
    fill: "#7B819B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 20,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3337 4.64104L20.6993 9.33337H17.1667C16.707 9.33337 16.3337 8.88887 16.3337 8.34171V4.64104ZM23.0315 8.54937L17.8457 2.71604C17.6252 2.47221 17.3113 2.33337 16.9823 2.33337H7.64899C6.00399 2.33337 4.66699 3.64237 4.66699 5.25004V22.75C4.66699 24.3577 6.00399 25.6667 7.64899 25.6667H20.3517C21.9967 25.6667 23.3337 24.3577 23.3337 22.75V9.33337C23.3337 9.04287 23.2263 8.76404 23.0315 8.54937Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/textFile.04c55b9d8f8e6dbe6d878814ddfa91c4.svg";
export { ForwardRef as ReactComponent };